"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Control = _interopRequireDefault(require("./Control.js"));

var _EventType = _interopRequireDefault(require("../pointer/EventType.js"));

var _proj = require("../proj.js");

var _events = require("../events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/control/MousePosition
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * @type {string}
 */
var PROJECTION = 'projection';
/**
 * @type {string}
 */

var COORDINATE_FORMAT = 'coordinateFormat';
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', Return>} MousePositionOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {string} [className='ol-mouse-position'] CSS class name.
 * @property {import("../coordinate.js").CoordinateFormat} [coordinateFormat] Coordinate format.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the
 * control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {string|boolean} [placeholder] Markup to show when the mouse position is not
 * available (e.g. when the pointer leaves the map viewport).  By default, a non-breaking space
 * is rendered when the mouse leaves the viewport.  To render something else, provide a string
 * to be used as the text content (e.g. 'no position' or '' for an empty string).  Set the placeholder
 * to `false` to retain the last position when the mouse leaves the viewport.  In a future release, this
 * will be the default behavior.
 * @property {string} [undefinedHTML='&#160;'] This option is deprecated.  Use the `placeholder` option instead.
 */

/**
 * @classdesc
 * A control to show the 2D coordinates of the mouse cursor. By default, these
 * are in the view projection, but can be in any supported projection.
 * By default the control is shown in the top right corner of the map, but this
 * can be changed by using the css selector `.ol-mouse-position`.
 *
 * On touch devices, which usually do not have a mouse cursor, the coordinates
 * of the currently touched position are shown.
 *
 * @api
 */

var MousePosition =
/** @class */
function (_super) {
  __extends(MousePosition, _super);
  /**
   * @param {Options} [opt_options] Mouse position options.
   */


  function MousePosition(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    var element = document.createElement('div');
    element.className = options.className !== undefined ? options.className : 'ol-mouse-position';
    _this = _super.call(this, {
      element: element,
      render: options.render,
      target: options.target
    }) || this;
    /***
     * @type {MousePositionOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {MousePositionOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {MousePositionOnSignature<void>}
     */

    _this.un;

    _this.addChangeListener(PROJECTION, _this.handleProjectionChanged_);

    if (options.coordinateFormat) {
      _this.setCoordinateFormat(options.coordinateFormat);
    }

    if (options.projection) {
      _this.setProjection(options.projection);
    }
    /**
     * Change this to `false` when removing the deprecated `undefinedHTML` option.
     * @type {boolean}
     */


    var renderOnMouseOut = true;
    /**
     * @type {string}
     */

    var placeholder = '&#160;';

    if ('undefinedHTML' in options) {
      // deprecated behavior
      if (options.undefinedHTML !== undefined) {
        placeholder = options.undefinedHTML;
      }

      renderOnMouseOut = !!placeholder;
    } else if ('placeholder' in options) {
      if (options.placeholder === false) {
        renderOnMouseOut = false;
      } else {
        placeholder = String(options.placeholder);
      }
    }
    /**
     * @private
     * @type {string}
     */


    _this.placeholder_ = placeholder;
    /**
     * @private
     * @type {boolean}
     */

    _this.renderOnMouseOut_ = renderOnMouseOut;
    /**
     * @private
     * @type {string}
     */

    _this.renderedHTML_ = element.innerHTML;
    /**
     * @private
     * @type {?import("../proj/Projection.js").default}
     */

    _this.mapProjection_ = null;
    /**
     * @private
     * @type {?import("../proj.js").TransformFunction}
     */

    _this.transform_ = null;
    return _this;
  }
  /**
   * @private
   */


  MousePosition.prototype.handleProjectionChanged_ = function () {
    this.transform_ = null;
  };
  /**
   * Return the coordinate format type used to render the current position or
   * undefined.
   * @return {import("../coordinate.js").CoordinateFormat|undefined} The format to render the current
   *     position in.
   * @observable
   * @api
   */


  MousePosition.prototype.getCoordinateFormat = function () {
    return (
      /** @type {import("../coordinate.js").CoordinateFormat|undefined} */
      this.get(COORDINATE_FORMAT)
    );
  };
  /**
   * Return the projection that is used to report the mouse position.
   * @return {import("../proj/Projection.js").default|undefined} The projection to report mouse
   *     position in.
   * @observable
   * @api
   */


  MousePosition.prototype.getProjection = function () {
    return (
      /** @type {import("../proj/Projection.js").default|undefined} */
      this.get(PROJECTION)
    );
  };
  /**
   * @param {MouseEvent} event Browser event.
   * @protected
   */


  MousePosition.prototype.handleMouseMove = function (event) {
    var map = this.getMap();
    this.updateHTML_(map.getEventPixel(event));
  };
  /**
   * @param {Event} event Browser event.
   * @protected
   */


  MousePosition.prototype.handleMouseOut = function (event) {
    this.updateHTML_(null);
  };
  /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../PluggableMap.js").default|null} map Map.
   * @api
   */


  MousePosition.prototype.setMap = function (map) {
    _super.prototype.setMap.call(this, map);

    if (map) {
      var viewport = map.getViewport();
      this.listenerKeys.push((0, _events.listen)(viewport, _EventType["default"].POINTERMOVE, this.handleMouseMove, this));

      if (this.renderOnMouseOut_) {
        this.listenerKeys.push((0, _events.listen)(viewport, _EventType["default"].POINTEROUT, this.handleMouseOut, this));
      }

      this.updateHTML_(null);
    }
  };
  /**
   * Set the coordinate format type used to render the current position.
   * @param {import("../coordinate.js").CoordinateFormat} format The format to render the current
   *     position in.
   * @observable
   * @api
   */


  MousePosition.prototype.setCoordinateFormat = function (format) {
    this.set(COORDINATE_FORMAT, format);
  };
  /**
   * Set the projection that is used to report the mouse position.
   * @param {import("../proj.js").ProjectionLike} projection The projection to report mouse
   *     position in.
   * @observable
   * @api
   */


  MousePosition.prototype.setProjection = function (projection) {
    this.set(PROJECTION, (0, _proj.get)(projection));
  };
  /**
   * @param {?import("../pixel.js").Pixel} pixel Pixel.
   * @private
   */


  MousePosition.prototype.updateHTML_ = function (pixel) {
    var html = this.placeholder_;

    if (pixel && this.mapProjection_) {
      if (!this.transform_) {
        var projection = this.getProjection();

        if (projection) {
          this.transform_ = (0, _proj.getTransformFromProjections)(this.mapProjection_, projection);
        } else {
          this.transform_ = _proj.identityTransform;
        }
      }

      var map = this.getMap();
      var coordinate = map.getCoordinateFromPixelInternal(pixel);

      if (coordinate) {
        var userProjection = (0, _proj.getUserProjection)();

        if (userProjection) {
          this.transform_ = (0, _proj.getTransformFromProjections)(this.mapProjection_, userProjection);
        }

        this.transform_(coordinate, coordinate);
        var coordinateFormat = this.getCoordinateFormat();

        if (coordinateFormat) {
          html = coordinateFormat(coordinate);
        } else {
          html = coordinate.toString();
        }
      }
    }

    if (!this.renderedHTML_ || html !== this.renderedHTML_) {
      this.element.innerHTML = html;
      this.renderedHTML_ = html;
    }
  };
  /**
   * Update the projection. Rendering of the coordinates is done in
   * `handleMouseMove` and `handleMouseUp`.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */


  MousePosition.prototype.render = function (mapEvent) {
    var frameState = mapEvent.frameState;

    if (!frameState) {
      this.mapProjection_ = null;
    } else {
      if (this.mapProjection_ != frameState.viewState.projection) {
        this.mapProjection_ = frameState.viewState.projection;
        this.transform_ = null;
      }
    }
  };

  return MousePosition;
}(_Control["default"]);

var _default = MousePosition;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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